module.exports = __webpack_public_path__ + "static/media/rapidtest_dashboard_logo.6584d440.png";